export default "/assets/logo-8d58e9cc38f69fff79ee7c0eecebd3947b55c5617c707ce4d1507bc66dd49c6b.png";